import axios from 'axios'
import Utils from '../../../utils/utils'
import CONST from '../../../utils/const'
import config from '../../../config'

export async function getEstimate(condition = {}) {
  let response = {}
  
  try {
    response = await axios.get(`${config.eastCoastDataApi()}BaseData/PassengerEstimateSetting`)

  } catch (err) {
    console.error('iisi getEstimate: ', err)
  }

  Utils.setApiResponsSuccess(response)
  handleEstimate(response)
  return response

}

function handleEstimate(response) {
  if(Utils.isEmptyObject(response) || Utils.isEmptyObject(response.data)) {
    return
  }

  const data = Utils.arrayGroupBy(response.data, 'isInternal', CONST.ESTIMATE_KEY)
  response.data = data

}

export async function putEstimate(estimate = {}) {
  if(Utils.isEmptyObject(estimate.id) || estimate.id < 0) {
    console.error('iisi putEstimate: id error')
    return
  }

  let response = {}
  let idQuery = `/${estimate.id}`

  try {
    response = await axios.put(`${config.eastCoastDataApi()}BaseData/PassengerEstimateSetting${idQuery}`, estimate)
  } catch (err) {
    console.error('iisi putEstimate: ', err)
  }

  Utils.setApiResponsSuccess(response)
  return response
}
